/**
 * The asset listing provider contains methods for operating on an existing list of assets or validation assets
 * (currently only the latter). This allows us to have a unified source of logic/truth for filtering/sorting
 * assets on the frontend.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { ClassProvider, NOTHING_I_KNOW_IDENTIFIER } from './class';
var AssetListingProvider = /** @class */ (function (_super) {
    __extends(AssetListingProvider, _super);
    function AssetListingProvider(classProvider) {
        var _this = _super.call(this) || this;
        _this.classProvider = classProvider;
        return _this;
    }
    AssetListingProvider.prototype.applyRecognitionFramesFilter = function (recognitionFrames, classID, filteringResults, classesTable) {
        var _this = this;
        var filteredAssets = [];
        if (!recognitionFrames || recognitionFrames.length === 0) {
            return [];
        }
        if (classID || filteringResults !== 'none') {
            filteredAssets = recognitionFrames.filter(function (asset) {
                var matchFilter = true;
                if (classID) {
                    if (classID == NOTHING_I_KNOW_IDENTIFIER) {
                        matchFilter = _this.classProvider.isClassNothingIKnow(asset.predictedClass, false);
                    }
                    else if (asset.actualClass) {
                        var actualClass = classesTable.get(asset.actualClass);
                        matchFilter = actualClass !== undefined && actualClass.id === classID;
                    }
                    else if (asset.predictedClass) {
                        var predictedClass = classesTable.get(asset.predictedClass);
                        matchFilter = predictedClass !== undefined && predictedClass.id === classID;
                    }
                }
                if (matchFilter && filteringResults !== 'none') {
                    if (filteringResults === 'correct') {
                        matchFilter = asset.actualClass === asset.predictedClass;
                    }
                    else if (filteringResults === 'incorrect') {
                        matchFilter = asset.actualClass !== asset.predictedClass;
                    }
                }
                return matchFilter;
            });
        }
        else {
            // If nothing's being filtered out, return a shallow copy of the array to prevent
            // referencing errors.
            filteredAssets = recognitionFrames.slice(0);
        }
        return filteredAssets;
    };
    AssetListingProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ClassProvider])
    ], AssetListingProvider);
    return AssetListingProvider;
}(BaseProvider));
export { AssetListingProvider };
//# sourceMappingURL=asset_listing.js.map


// WEBPACK FOOTER //
// ./src/providers/asset_listing.ts.pre-build-optimizer.js